// eslint-disable-next-line no-shadow
export enum ModalType {
    Action = 'action',
    DocumentQRCodes = 'qrcodes'
}
